export default {
  "introductionCorporate.specialMembers.b-p-and-r-m":
    "Biotechnology, Pharmaceuticals and Regenerative Medicine",
  "introductionCorporate.specialMembers.consulting-and-support-organizations":
    "Consulting and Commercialization Support Organizations",
  "introductionCorporate.specialMembers.education-and-research":
    "Education and research",
  "introductionCorporate.specialMembers.healthcare-services":
    "Healthcare IT and Services",
  "introductionCorporate.specialMembers.medical-and-welfare":
    "Medical and Welfare",
  "introductionCorporate.specialMembers.medical-devices-and-testing-equipment":
    "Medical Devices and Testing Equipment",
  "introductionCorporate.specialMembers.non-profit-organizations":
    "Non-Profit Organizations",
  "introductionCorporate.specialMembers.others": "Others",
  "introductionCorporate.specialMembers.patent-and-law": "Patent and Law",
  "introductionCorporate.specialMembers.private-companies": "Private Companies",
  "introductionCorporate.specialMembers.public-agencies": "Public Agencies",
  "introductionCorporate.specialMembers.society": "Society",
  "introductionCorporate.specialMembers.special-members": "All Special Member",
  "introductionCorporate.specialMembers.universities": "Universities",
  "introductionCorporate.specialMembers.vcs": "VCs",

  "introductionCorporate.specialMembers.title": "Special Membership Directory",
  "introductionCorporate.specialMembers.description":
    "List of corporations and organizations registered as LINK-J Special Members",
  "introductionCorporate.specialMembers.ogSiteName": "LINK-J",
  "introductionCorporate.specialMembers.ogDescription":
    "List of corporations and organizations registered as LINK-J Special Members",
  "introductionCorporate.specialMembers.ogTitle":
    "Special Membership Directory",

  "introductionCorporate.specialMembers.itemTitle": "List of Special Members",
  "introductionCorporate.specialMembers.headingPage": "List of Special Members",
  "introductionCorporate.specialMembers.tenantTag": "tenant",
  "introductionCorporate.specialMembers.aboutTenant1":
    "＊ We are publishing companies and organizations that can post.",
  "introductionCorporate.specialMembers.aboutTenant2": `＊ The "tenant" mark indicates the followings: `,
  "introductionCorporate.specialMembers.aboutTenant3":
    "Life Science Building series",
  "introductionCorporate.specialMembers.aboutTenant4":
    ", Nihonbashi 1-chome Mitsui Building, Nihonbashi Honmachi YS Building and Muromachi Higashi Mitsui Building, etc.",
} as const;
